import { useState } from "react";
import { Plus, Tags, Trash2 } from "lucide-react";
import { toast } from "sonner";
import type { Product, ProductVariant, VariantAlias } from "../types";
import { addVariantAlias, removeVariantAlias } from "../services/aliases";
import { Modal } from "./Modal";

interface AliasManagerProps {
  open: boolean;
  product?: Product;
  variant?: ProductVariant;
  aliases: VariantAlias[];
  onClose: () => void;
}

export function AliasManager({ open, product, variant, aliases, onClose }: AliasManagerProps) {
  const [value, setValue] = useState("");
  const [busy, setBusy] = useState(false);
  const current = aliases.filter((alias) => alias.variantId === variant?.id);
  const add = async (event: React.FormEvent) => {
    event.preventDefault();
    if (!variant) return;
    setBusy(true);
    try {
      await addVariantAlias(variant.id, value);
      setValue("");
      toast.success("Nome alternativo salvo. Ele já poderá ser usado na importação de vendas.");
    } catch (error) { toast.error(error instanceof Error ? error.message : "Não foi possível salvar o nome alternativo."); }
    finally { setBusy(false); }
  };
  const remove = async (alias: VariantAlias) => {
    setBusy(true);
    try { await removeVariantAlias(alias.id); toast.success("Nome alternativo removido."); }
    catch (error) { toast.error(error instanceof Error ? error.message : "Não foi possível remover."); }
    finally { setBusy(false); }
  };

  return <Modal open={open} onClose={onClose} title="Nomes equivalentes da cor" description={product && variant ? `${product.sku} / ${variant.colorName}` : undefined}>
    <div className="form-stack">
      <div className="alias-explanation"><Tags size={20} /><p>Cadastre aqui como essa mesma cor aparece nos marketplaces. Exemplo: na cor <strong>Verde</strong>, adicione <strong>Verde Menta</strong> ou <strong>{product?.sku}-Verde Menta</strong>. Ambos darão baixa no mesmo estoque.</p></div>
      <form className="alias-add-form" onSubmit={add}>
        <label><span>Novo nome alternativo</span><input value={value} onChange={(event) => setValue(event.target.value)} placeholder="Ex.: Verde Menta" required /></label>
        <button className="primary-button" disabled={busy || !value.trim()}><Plus size={17} />Adicionar</button>
      </form>
      <div className="alias-list">
        {current.length ? current.map((alias) => <div key={alias.id}><div><strong>{alias.alias}</strong><span>{alias.kind === "sku" ? "SKU de marketplace" : "Nome de cor"} · {alias.source}</span></div><button type="button" className="icon-button danger" onClick={() => remove(alias)} disabled={busy} aria-label={`Remover ${alias.alias}`}><Trash2 size={16} /></button></div>) : <p>Nenhum nome alternativo cadastrado para esta cor.</p>}
      </div>
      <div className="modal-actions"><button type="button" className="ghost-button" onClick={onClose}>Fechar</button></div>
    </div>
  </Modal>;
}
